import { WebLayout } from "@/components/shared/layout/homepage.web";
import { Column, Container } from "@/components/ui/layout";
import { NotificationList } from "@/containers/notifications/notification-list";
import { useOutlet, useParams } from "react-router-dom";
import { Button, View } from "@/components/ui";
import { IconButton } from "@/components/ui/icon-button";
import { useRoute } from "@/components/shared/router";
import { Typography } from "@/components/shared/typography";
import { useWindowDimensions } from "@/components/hooks/use-window-dimension";
import { useAuthState } from "@/store/auth";

export function NotificationListPage() {
  const outlet = useOutlet();
  const { push, pull } = useRoute();
  const { isMobile } = useWindowDimensions();
  const { id } = useParams<{ id: string }>();
  const unreadNotificationCount = useAuthState(
    (state) => state.data.unreadNotificationCount,
  );

  return (
    <WebLayout>
      <Container gap="xl">
        <Column desktop={id ? "6" : "full"} mobile={id ? "none" : "full"}>
          <View className="flex flex-row items-center justify-between gap-1 md:p-4">
            <View className="flex flex-row items-center gap-1 p-2">
              <IconButton
                iconName="arrowLeft"
                variant={isMobile ? "ghost" : "secondary"}
                color="foreground"
                rounded="full"
                size="md"
                onClick={() => (id ? push("/notifications") : pull())}
                className="mr-1"
              />
              <Typography>
                Notification{" "}
                {unreadNotificationCount > 0
                  ? `(${String(unreadNotificationCount)})`
                  : ""}
              </Typography>
            </View>

            <Button
              variant="tertiary"
              color="CTA2"
              iconColor="CTA2"
              size="md"
              iconName="gear"
              children="Settings"
              onClick={() => push("/profile/notification-settings")}
            />
          </View>
          <NotificationList />
        </Column>
        {outlet && <Column desktop="6">{outlet}</Column>}
      </Container>
    </WebLayout>
  );
}
